export enum SectionType {
  PARAGRAPH = 'paragraph',
  BULLET_LIST = 'bullet-list',
  NUMBERED_LIST = 'numbered-list',
  TABLE = 'table',
  KPI = 'kpi',
  INSTITUTIONAL_HIGHLIGHTS = 'institutional-highlights',
  INCOME_STATEMENT_TYPE_CREDIT_PROPOSAL = 'income-statement-type-credit-proposal',
  Financial_data = 'Financial-Data',
  CHART = 'chart',
  RISK_SECTION = 'risk-section',
  SUMMARY_TERMS = 'summary-terms',
  IRS_RATING = 'irs-rating',
  IRS_RATING_SUMRY = 'irs-rating-sumry',
  RECOMMENDATIONS = 'recommendations',
  FINANCIAL_PERFORMANCE = 'financial-performance',
  STRUCTURED_REPORT = 'structured-report',
  CREDIT_PROPOSAL_EXTRA_TYPE = 'credit-proposal-extra-type',
  TERMS_PARAMETERS = 'terms-parameters',
  FINANCIAL_ANALYSIS = 'FinancialAnalysis',
  PROPOSED_DISBURSEMENT = 'proposed-disbursement',
  BORROW_PERPOSAL_REVIEW = 'Borrow-perposal-review',
  REPAYMENT_PLAN = 'repayment-plan',
  CALCULATE_REPAYMENT_PLAN = 'calculate-repayment-plan',
  DISBURSEMENT_REPAYMENT_SUMMARY = 'disbursement-repayment-summary',
  FINANCIAL_ANALYSIS_DETIALS = 'FinancialAnalysisDetails',
  DOCUMENTS = 'documents',
}
